import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SingleTabEditDialog,
  SingleTabEditDialogProps
} from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { EditTimeTrackingActivityForm } from '../EditTimeTrackingActivityForm/EditTimeTrackingActivityForm';

export type EditTimeTrackingActivityDialogProps = PropsWithoutChildren<
  Omit<SingleTabEditDialogProps, 'tabTitle'>
> & {
  timeTrackingActivity: TimeTrackingActivity;
};

export const EditTimeTrackingActivityDialog: FunctionComponent<EditTimeTrackingActivityDialogProps> =
  React.memo((props) => {
    const { timeTrackingActivity, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });
    const { t } = useTranslation();

    const handlePropertyChanged = useModifyEntityCallback(
      EntityName.TimeTrackingActivity
    );

    return (
      <SingleTabEditDialog
        {...remainingProps}
        tabTitle={t(
          'components.timeTrackingActivity.EditTimeTrackingActivityDialog.title'
        )}
      >
        <EditTimeTrackingActivityForm
          timeTrackingActivity={timeTrackingActivity}
          onPropertyChanged={handlePropertyChanged}
          data-testid="EditTimeTrackingActivityDialog.Form"
        ></EditTimeTrackingActivityForm>
      </SingleTabEditDialog>
    );
  });
